<template>
  <v-navigation-drawer width="25%" v-model="localDrawer" right temporary app>
    <v-list-item class="primary">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium white--text">
          Histórico do lançamento de planos
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium text-h6">
          Historico de lançamento do
          {{ bimestre + 1 }}° bimestre
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>

    <div v-if="plano.audits.length > 0">
      <v-list class="px-3" v-for="(audit, index) in plano.audits" :key="audit.id" dense>
        <v-list-item-title class="primary rounded-lg pt-4 ps-2">
          <p class="font-weight-light subtitle-1 text-caption">
            Nome:
            <strong>{{ audit.username ? audit.username : "- - -" }}</strong>
          </p>
        </v-list-item-title>
        <v-list-item-title>
          <p class="font-weight-light subtitle-1 text-caption mt-3">
            Tipo de operação:
            <strong>{{ audit.event ? events[audit.event] : "- - -" }}</strong>
          </p>
        </v-list-item-title>
        <span>
          <v-list-item-title>
            <strong>Anterior</strong>
            <p
              v-for="(value, index) in audit.old_values"
              :key="index"
              class="font-weight-light subtitle-1 text-caption text-wrap"
            >
              <span v-if="index === 'status_id'">
                Status: {{ getSituacaoPlano(value).descricao ?? "- - -" }}
              </span>
              <span v-else-if="index === 'tematica'">
                <strong>UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'objeto_conhecimento'">
                <strong>OBJETOS DO CONHECIMENTO</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'habilidades'">
                <strong>HABILIDADES</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'metodologia'">
                <strong>METODOLOGIA</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'recursos_didaticos'">
                <strong>RECURSOS DIDÁTICOS</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'avaliacao_aprendizagem'">
                <strong>AVALIAÇÃO DA APRENDIZAGEM</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'referencias'">
                <strong>REFERÊNCIAS</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'observacoes'">
                <strong>OBSERVACÕES</strong>:
                {{ value }}
              </span>
              <span v-else-if="index !== 'ods'">
                <strong>{{ index.split("_").join(" ").toUpperCase() }}</strong
                >: {{ value }}
              </span>
            </p>
            <v-btn
              v-if="podeRestaurarPlano"
              block
              color="primary"
              class="font-weight-light subtitle-1 text-caption mb-2"
              style="color: black"
              @click="restaurarPlano(plano.instrutorDisciplinaTurma_id, plano.id, audit.id)"
            >
              <strong>Restaurar Versão Anterior</strong>
            </v-btn>
          </v-list-item-title>
          <v-list-item-title>
            <strong>Depois</strong>
            <p
              v-for="(value, index) in audit.new_values"
              :key="index"
              class="font-weight-light subtitle-1 text-caption text-wrap"
            >
              <span v-if="index === 'status_id'">
                Status: {{ getSituacaoPlano(value).descricao ?? "- - -" }}
              </span>
              <span v-else-if="index === 'tematica'">
                <strong>UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'objeto_conhecimento'">
                <strong>OBJETOS DO CONHECIMENTO</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'habilidades'">
                <strong>HABILIDADES</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'metodologia'">
                <strong>METODOLOGIA</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'recursos_didaticos'">
                <strong>RECURSOS DIDÁTICOS</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'avaliacao_aprendizagem'">
                <strong>AVALIAÇÃO DA APRENDIZAGEM</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'referencias'">
                <strong>REFERÊNCIAS</strong>:
                {{ value }}
              </span>
              <span v-else-if="index === 'observacoes'">
                <strong>OBSERVACÕES</strong>:
                {{ value }}
              </span>
              <span v-else-if="index !== 'ods'">
                <strong>{{ index.split("_").join(" ").toUpperCase() }}</strong
                >: {{ value }}
              </span>
            </p>
          </v-list-item-title>
        </span>
        <v-list-item-title>
          <p class="font-weight-light subtitle-1 text-caption">
            Data da operação:
            <strong>{{ audit.created_at ? dateFormat(audit.created_at) : "- - -" }}</strong>
            <strong> às {{ audit.created_at ? dateFormatHour(audit.created_at) : "- - -" }}</strong>
          </p>
        </v-list-item-title>
        <v-divider v-if="index + 1 != plano.audits.length"></v-divider>
      </v-list>
    </div>
    <v-list-item-title v-else>
      <strong class="subtitle-1 text-caption">Operações não encontradas</strong>
    </v-list-item-title>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from "vuex";
import { dateFormat, dateFormatHour } from "@/plugins/filters";

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    gestao_id: {
      type: Number,
      required: true,
    },
    bimestre: {
      type: Number,
      required: true,
    },
    disciplina_id: {
      type: Number,
      required: true,
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    async localDrawer() {
      this.$emit("input", this.localDrawer);
      if (this.localDrawer) {
        await this.historicoPlanosLancados();
      }
    },
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeRestaurarPlano() {
      return this.$constants.rolesParaGestores.find(
        (rpg) =>
          rpg.name ===
          this.user.roles
            .filter((role) => role.name === "super-admin" || role.name === "admin")
            .find((r) => true)?.name
      );
    },
  },
  data() {
    return {
      situacoesPlanos: [
        { id: "1", descricao: "Plano Confirmado", cor: "green" },
        { id: "2", descricao: "Aguardando confirmação", cor: "orange" },
        { id: "3", descricao: "Plano Inválido", cor: "red" },
      ],
      localDrawer: this.value,
      dialog: false,
      plano: {
        audits: [],
      },
      dateFormat,
      dateFormatHour,
      events: {
        created: "Criado",
        updated: "Atualizado",
        deleted: "Deletado",
        restored: "Restaurados",
      },
      masculino: "https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png",
      feminino:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbUqkRN4QaEzCW4brgWElc7lv8HdwP8RyxJ89WdDWAoIO-rEUIACXkEXG4n2mDGMLuz4Q&usqp=CAU",
    };
  },
  methods: {
    parseArray(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return [];
      }
    },
    getDescricaoHabilidade(id) {
      const habilidade = this.habilidades?.find((h) => h.id === id);
      return habilidade?.descricao ?? `ID ${id}`;
    },
    getSituacaoPlano(status_id) {
      const id = String(status_id);
      return (
        this.situacoesPlanos.find((s) => String(s.id) === id) || {
          descricao: "- - -",
          cor: "inherit",
        }
      );
    },
    async historicoPlanosLancados() {
      try {
        const response = await this.$services.gestoesDeAulasService.historicoPlanosLancados(
          this.gestao_id,
          this.bimestre,
          this.disciplina_id
        );

        this.plano = response.historicoLancamento
          ? response.historicoLancamento
          : {
              audits: [],
            };
      } catch (error) {
        this.$handleError(error);
      }
    },
    async restaurarPlano(instrutorDisciplinaTurma_id, plano_id, audit_id) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja restaurar este plano?",
        confirmationCode: plano_id,
        confirmationMessage: `Por favor, digite <strong>${plano_id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Restaurando Plano");
              try {
                await this.$services.gestoesDeAulasService.restaurarPlano(
                  instrutorDisciplinaTurma_id,
                  plano_id,
                  audit_id
                );
                this.$emit("planoRestaurado");
                this.$toast.success("Plano restaurado com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              } finally {
                this.$loaderService.close();
              }
            },
            props: {
              color: "error",
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
